// extracted by mini-css-extract-plugin
export default {"dotsWrapper":"Dots_dotsWrapper__pRO9X","dot":"Dots_dot__M0EAO"};